import { isEmpty, omit } from 'lodash-es'

import { request } from '../sharedLegacy/utils'

export const getAudienceList = (filters, offset = 0, limit = 101) => {
  return new Promise((resolve, reject) => {
    const url = '/api/audience/list'

    request({
      url,
      method: 'GET',
      data: {
        include_timelines_p: true,
        include_events_p: false,
        orderby: 'recent',
        order: 'desc',
        size: limit,
        offset,
        ...filters,
      },
      success: resolve,
      error: reject,
    })
  })
}

export const getAudienceForObject = (
  objectId,
  filters,
  offset = 0,
  limit = 101
) => {
  return new Promise((resolve, reject) => {
    const url = '/api/audience/list'

    request({
      url,
      method: 'GET',
      data: {
        objects: objectId,
        include_timelines_p: true,
        include_events_p: false,
        orderby: 'recent',
        order: 'desc',
        size: limit,
        offset,
        ...filters,
      },
      success: resolve,
      error: reject,
    })
  })
}

export const fetchProfile = (uuid, filters) => {
  return new Promise((resolve, reject) => {
    const url = '/api/audience/list'

    request({
      url,
      method: 'GET',
      data: {
        uuid,
        include_timelines_p: true,
        ...filters,
      },
      success(responseData) {
        if (isEmpty(responseData.profiles)) {
          reject()
          return
        }

        resolve(responseData.profiles[0])
      },
      error: reject,
    })
  })
}

export const getAudienceRealtimeData = () => {
  return new Promise((resolve, reject) => {
    const url = '/api/audience/realtime'

    request({
      url,
      method: 'GET',
      success: resolve,
      error: reject,
    })
  })
}

export const followPerson = (identifier) => {
  const url = '/api/audience/follow/subscribe'
  return request({
    url,
    data: { identifier },
  })
}

export const unfollowPerson = (identifier) => {
  const url = '/api/audience/follow/unsubscribe'
  return request({
    url,
    data: { identifier },
  })
}

export const fetchSubscribers = () => {
  return new Promise((resolve, reject) => {
    const url = '/api/audience/follow/subscriptions'

    request({
      url,
      method: 'GET',
      success: resolve,
      error: reject,
    })
  })
}

export const fetchMetrics = (filters = {}, excludeExtended = undefined) => {
  const url = '/api/audience/metrics'
  const filtersWithoutOrdering = omit(filters, ['order', 'orderby'])
  const data = {
    size: 10,
    ...filtersWithoutOrdering,
  }

  if (!excludeExtended) {
    data.include_extended_metrics_p = 1
  }

  return request({
    url,
    method: 'GET',
    data,
  })
}

export const fetchIdentitySources = () => {
  return new Promise((resolve, reject) => {
    const url = '/api/audience/identity-sources'

    request({
      url,
      method: 'GET',
      success: resolve,
      error: reject,
    })
  })
}

export const fetchCustomFields = () => {
  return new Promise((resolve, reject) => {
    const url = '/api/audience/field/list'

    request({
      url,
      method: 'POST',
      success: resolve,
      error: reject,
    })
  })
}

export const fetchScoring = () => {
  return new Promise((resolve, reject) => {
    const url = '/api/audience/scoring/get'

    request({
      url,
      success: resolve,
      error: reject,
    })
  })
}

export const saveScoring = (values) => {
  const { identityWeight, sessionWeight, minuteWeight, videoWeight } = values

  return request({
    url: '/api/audience/scoring/set',
    method: 'POST',
    data: {
      identity_weight: identityWeight,
      video_weight: videoWeight,
      minute_weight: minuteWeight,
      session_weight: sessionWeight,
    },
  })
}

export const searchAudience = (text) => {
  return new Promise((resolve, reject) => {
    const url = `/api/audience/search?text=${text}`

    request({
      url,
      method: 'GET',
      success: resolve,
      error: reject,
    })
  })
}

export const getCompanies = (filters, offset = 0, limit = 101) => {
  const url = '/api/audience/companies'
  return request({
    url,
    method: 'GET',
    data: {
      include_profiles_p: 1,
      orderby: 'recent',
      order: 'desc',
      size: limit,
      offset,
      ...filters,
    },
  })
}

export const getColleaguesList = (data = {}) => {
  const url = '/api/user/list'
  return request({
    url,
    data: {
      ...data,
      has_audience_subscriptions_p: 1,
      exclude_requesting_user_p: 1,
    },
  })
}

export const getColleaguesFollowing = (data = {}) => {
  const url = '/api/user/list'
  return request({
    url,
    data,
  })
}

export const fetchWebinar = (liveId) => {
  return request({
    url: '/api/live/list',
    method: 'GET',
    data: {
      live_format: 'webinar',
      live_id: liveId,
      stream_preview_p: 1,
    },
  })
}

export const fetchPolls = (objectId, token) => {
  return request({
    url: '/api/poll/list',
    method: 'GET',
    data: {
      object_id: objectId,
      object_token: token,
    },
  })
}

export const unregister = (objectId, uuid) =>
  request({
    url: '/api/audience/unregister',
    method: 'POST',
    data: {
      object_id: objectId,
      uuid,
    },
  })
